export default function isObject<T>(val: T | T[]): val is T {
  if (val === null) {
    return false;
  }
  return typeof val === "function" || typeof val === "object";
}
